import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterControls = ({ 
  selectedPeriod, 
  onPeriodChange, 
  selectedPrize, 
  onPrizeChange,
  selectedMode,
  onModeChange,
  onExportPDF,
  onExportCSV
}) => {
  const periodOptions = [
    { value: 'today', label: 'Hoy' },
    { value: 'week', label: 'Esta Semana' },
    { value: 'month', label: 'Este Mes' },
    { value: 'all', label: 'Todo el Tiempo' }
  ];

  const prizeOptions = [
    { value: 'all', label: 'Todos los Premios' },
    { value: 'Descuento 20%', label: 'Descuento 20%' },
    { value: 'Muestra Gratis', label: 'Muestra Gratis' },
    { value: 'Consulta Gratuita', label: 'Consulta Gratuita' },
    { value: 'Material Educativo', label: 'Material Educativo' },
    { value: 'Sin Premio', label: 'Sin Premio' }
  ];

  const modeOptions = [
    { value: 'all', label: 'Todos los Modos' },
    { value: 'autonomous', label: 'Modo Autónomo' },
    { value: 'assisted', label: 'Modo Asistido' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-md">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">
        Filtros y Exportación
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Select
          label="Período"
          options={periodOptions}
          value={selectedPeriod}
          onChange={onPeriodChange}
        />
        
        <Select
          label="Tipo de Premio"
          options={prizeOptions}
          value={selectedPrize}
          onChange={onPrizeChange}
        />
        
        <Select
          label="Modo de Operación"
          options={modeOptions}
          value={selectedMode}
          onChange={onModeChange}
        />
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="default"
          onClick={onExportPDF}
          iconName="FileText"
          iconPosition="left"
          className="flex-1"
        >
          Exportar PDF
        </Button>
        <Button
          variant="outline"
          onClick={onExportCSV}
          iconName="Download"
          iconPosition="left"
          className="flex-1"
        >
          Exportar CSV
        </Button>
      </div>
    </div>
  );
};

export default FilterControls;